var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckEligibilityMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 15.61L14.4715 20.748L22.9428 12.2767L22.0002 11.334L14.4715 18.8627L10.2762 14.6673L9.3335 15.61Z",
    fill: "#B4B4B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0002 6.6674C25.8795 6.6674 20.6368 3.3074 16.7922 0.430063C16.3182 0.0753958 15.6822 0.0753958 15.2088 0.430063C11.3635 3.3074 6.12083 6.6674 4.00016 6.6674H3.3335V7.33406C3.3335 28.4987 14.4408 31.6627 15.7075 31.9541C15.8062 31.9767 15.9028 31.9881 16.0002 31.9881C16.0975 31.9881 16.1948 31.9767 16.2935 31.9541C17.1595 31.7547 20.2102 30.8341 23.0948 27.3441C26.7922 22.8701 28.6668 16.1381 28.6668 7.33406V6.6674H28.0002ZM16.0055 30.6541C14.8562 30.3901 4.87083 27.5254 4.6695 7.9374C7.8635 7.38206 13.5748 3.31673 15.9922 1.4974C18.4235 3.31673 24.1362 7.38206 27.3302 7.9374C27.1295 27.5261 17.1435 30.3901 16.0055 30.6541Z",
    fill: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckEligibilityMenu);
export default __webpack_public_path__ + "static/media/check_eligibility_menu.aab606574267370651e6e3cb5cc56ab9.svg";
export { ForwardRef as ReactComponent };